<template>
<panel>
  <p slot="header">
    Wiadomości
  </p>
  <p slot="actions">
    <ui-button type="flat" icon="add_circle" color="primary" @click="$router.push({name: 'admin.messages.create'})" >Dodaj wiadomość</ui-button>
    <ui-button type="flat" icon="refresh" color="primary" @click="reload()"></ui-button>
  </p>
  <messages-list></messages-list>
</panel>
</template>
<script>
import Messages from '../../services/Messages'
import EventEmitter from '../../services/EventEmitter'

export default {
  data () {
    return {
      item: Messages.getBaseItem()
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    reload () {
      EventEmitter.$emit('messages.reload')
    }
  }
}

</script>


// WEBPACK FOOTER //
// Dashboard.vue?cbdc7d8c